<template>
  <div class="popup-body">
    <div ref="stickySentinel" class="sentinel"></div>
    <div class="terms-privacy">
      <div class="terms-privacy-list" :class="{'is-sticky': isSticky, 'is-expanded': isExpanded}">
        <ul>
          <li><NuxtLink to="#tp-spec1-1" @click="resetBeforeMove">제 1 조  목 적</NuxtLink></li>
          <li>
            <NuxtLink to="#tp-spec1-2" @click="resetBeforeMove">제 2 조  정 의</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-3" @click="resetBeforeMove">제 3 조  약관의 효력 및 변경</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-4" @click="resetBeforeMove">제 4 조  약관 외 준칙</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-5" @click="resetBeforeMove">제 5 조  서비스 이용계약의 성립, 이용신청 및 승낙</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-6" @click="resetBeforeMove">제 6 조  서비스 이용 제한 또는 정지 및 자격상실</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-7" @click="resetBeforeMove">제 7 조  서비스의 이용 시간</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-8" @click="resetBeforeMove">제 8 조  서비스의 변경 및 중단</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-9" @click="resetBeforeMove">제 9 조  지식재산권 관련 법령의 준수</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-10" @click="resetBeforeMove">제 10 조  회원등급 산정</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-11" @click="resetBeforeMove">제 11 조  H캐시 이용</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-12" @click="resetBeforeMove">제 12 조  H캐시의 충전취소 및 환불</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-13" @click="resetBeforeMove">제 13 조  결제 수단</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-14" @click="resetBeforeMove">제 14 조  회사의 의무</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-15" @click="resetBeforeMove">제 15 조  회원의 의무</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-16" @click="resetBeforeMove">제 16 조  회원정보의 변경</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-17" @click="resetBeforeMove">제 17 조  아이디와 비밀번호 관리에 대한 의무와 책임</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-18" @click="resetBeforeMove">제 18 조  계약 해지</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-19" @click="resetBeforeMove">제 19 조  회원에 대한 통지</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-20" @click="resetBeforeMove">제 20 조  수신확인통지 및 구매신청 변경 및 취소</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-21" @click="resetBeforeMove">제 21 조  재화 등의 공급</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-22" @click="resetBeforeMove">제 22 조  청약철회 등</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-23" @click="resetBeforeMove">제 23 조  청약철회 등의 효과</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-24" @click="resetBeforeMove">제 24 조  모바일 쿠폰 주문취소 및 환불에 관한 특칙</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-25" @click="resetBeforeMove">제 25 조  회원의 개인정보보호</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-26" @click="resetBeforeMove">제 26 조  손해배상</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-27" @click="resetBeforeMove">제 27 조 서비스의 제공</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-28" @click="resetBeforeMove">제 28 조 양도 금지</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-29" @click="resetBeforeMove">제 29 조 면책사항</NuxtLink>
          </li>
          <li>
            <NuxtLink to="#tp-spec1-30" @click="resetBeforeMove">제 30 조 관할법원 등</NuxtLink>
          </li>
        </ul>
        <button type="button" v-if="isSticky && !isExpanded" class="more-badge" @click="isExpanded = !isExpanded"></button>
      </div>
      <div class="terms-privacy-cont">
        <p class="tp-tit01">제 1 장 총 칙</p>
        <p class="tp-tit02" id="tp-spec1-1">제 1 조 목 적</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">이 서비스 약관은 주식회사 현대이지웰(이하 “회사”라 합니다)이 제공하는 ‘Hcon’몰을 회원을 이용함에 있어 필요한 회사와 회원 간의 권리, 의무 및 책임 사항, 기타 필요한 사항을 규정함을 그 목적으로 합니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-2">제 2 조 정 의</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <ol class="ol-list pl11">
                <li>1. “모바일 쿠폰”이라 함은 전자적 방법(알림톡, MMS, LMS 등)으로 전송되어, 상품으로 교환 가능한 신유형 상품권을 말합니다.</li>
                <li>2. “Hcon”(이하 ‘사이트’)라 함은 “이용자”가 접속하여 웹사이트(<NuxtLink to="https://hcon.co.kr" class="inline-block" target="_blank" rel="noopenner noreferrer">https://hcon.co.kr</NuxtLink>)에서 견적서를 작성하고 “회원”이 “모바일 쿠폰”을 구매하여 “수신자”에게 전송할 수 있도록 하는 등의 서비스(이하 “서비스”라 한다)를 이용할 수 있도록 회사가 운영하는 가상의 영업장을 말하며, 아울러 Hcon을 운영하는 사업자의 의미로도 사용됩니다. </li>
                <li>3. ”이용자”라 함은 본 약관에 따라 회사가 제공하는 서비스를 제공받는 회원 및 비회원을 말합니다.</li>
                <li>4. “회원”이라 함은 회원가입을 진행하여 본 이용약관과 개인정보 처리방침에 동의 및 기업정보를 제공하고 회사로부터 서비스 이용 승낙을 받은 국내 법인사업자를 말합니다. 회원가입의 유형은 하기와 같습니다.
                  <ol class="ol-list pl11">
                    <li>가.	사이트에 접속하여 “회원”이 회원가입을 하는 방식</li>
                    <li>나.	SSO 연동을 통한 회원가입</li>
                  </ol>
                </li>
                <li>5. “비회원”이라 함은 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 자를 말합니다.</li>
                <li>6. “계정”이라 함은 회원의 식별과 서비스 이용을 위해 필요한 고유한 식별자를 의미합니다. </li>
                <li>7. "구매자”라 함은 사이트를 통해 "모바일 쿠폰"을 구매하여 수신자에게 전송하는 자를 말합니다. </li>
                <li>8. ”수신자”라 함은 “구매자”가 전송하는 “모바일 쿠폰”을 받는 자를 말합니다.</li>
                <li>9. "제휴처"라 함은 모바일 쿠폰을 상품으로 교환할 수 있는 온라인, 또는 오프라인 사용처를  말합니다.</li>
                <li>10.	"발행일"이라 함은 모바일 쿠폰이 발송된 날을 말합니다.</li>
                <li>11.	“H캐시”라 함은 “회원”이 서비스 내에서 결제수단을 대체하여 현금처럼 결제할 수 있는 전자적 지급수단을 말합니다.</li>
                <li>12.	"주문"이라 함은 “회원”이 서비스 내 결제를 통해 회사에 모바일 쿠폰의 즉시 발송 또는 예약발송을 요청하는 행위를 말합니다. </li>
                <li>13.	“회원등급”이라 함은 회사가 지정한 기준에 따라 적용되는 사이트의 계정별 등급으로, 회사는 회원등급에 따라 할인 등의 혜택을 차등하여 제공합니다.</li>
                <li>14.	“유효기간”이라 함은 모바일 쿠폰의 교환/사용이 가능한 기간으로, 사이트에서 판매되는 모든 모바일 쿠폰은 개별 모바일쿠폰에 명시된 유효기간으로 적용됩니다.</li>
                <li>15.	“적립금”이라 함은 구매 혜택, 이벤트 또는 보상 명목으로 지급되는 것을 말합니다. 전체 주문취소가 발생되어 적립금이 사용취소 되는 경우, 차감된 적립금이 환급되며, 부분 주문취소의 경우에도 동일합니다. 적립금 사용 취소 시, 취소 대상인 적립금의 유효기간이 만료되었을 경우 적립금으로 환급되고, 적립금의 유효기간은 개별 적립금에서 정한바에 따라 제공되고, 사이트 탈퇴 시 잔여 적립금은 소멸됩니다. “</li>
              </ol>
            </li>
            <li>②	본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 전자금융거래약관, 전자금융거래법, 전자상거래법 등 관계 법령 및 서비스별 안내에서 정하는 바에 의합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-3">제 3 조 약관의 효력 및 변경</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 본 약관의 내용과 상호, 영업소 소재지, 대표자의 성명, 사업자등록번호, 연락처(전화, 팩스, 전자우편 주소 등) 등을 회원이 쉽게 알 수 있도록 Hcon의 초기 서비스화면(전면)에 게시합니다. 다만, 약관의 내용은 회원이 연결화면을 통하여 볼 수 있도록 할 수 있습니다.</li>
            <li>②	회사는 회원본 약관에 동의하기에 앞서 약관에 정하여져 있는 내용 중 청약철회ㆍ배송책임ㆍ환불조건 등과 같은 중요한 내용을 회원이 이해할 수 있도록 별도의 연결화면 또는 팝업화면 등을 제공하여 회원의 확인을 구하여야 합니다.</li>
            <li>③	회사는 전자상거래 등에서의 소비자 보호에 관한 법률, 약관의 규제 등에 관한 법률, 전자문서 및 전자거래기본법, 전자금융거래법, 전자서명법, 정보통신망 이용 촉진 및 정보보호 등에 관한 법률, 소비자기본법 등 관련법을 위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.</li>
            <li>④	본 항에 따라 이용약관, 개별약관, 이용정책의 변경이 있는 경우 회사는 변경 내용의 효력발생일 7일 이전에 해당사항을 공지하며, 공지를 하면서 공지일로부터 변경시행일까지 거부의사를 표시하지 아니하면 승인한 것으로 본다는 뜻을 명확하게 고지하였음에도 회원의 의사표시가 없는 경우에는 변경된 사항을 승인한 것으로 봅니다. 다만, 회원에게 불리한 내용으로 변경할 때에는 30일 이전에 공지하며, 회원에게 개별 통지합니다. 이 경우 회사는 개정 전 내용과 개정 후 내용을 명확하게 비교하여 회원이 알기 쉽도록 표시합니다.</li>
            <li>⑤	회사는 약관을 개정할 경우 그 개정약관은 적용일자 이후에 체결된 계약에만 적용되고 그 이전에 체결된 계약에 대해서는 개정 전의 약관조항이 그대로 적용됩니다. 다만 이미 계약을 체결한 회원이 개정 약관의 적용을 받기를 원하는 뜻을 제4항에 따른 개정 약관의 공지기간 내에 회사에 송신하여 회사의 동의를 받은 경우에는 개정 약관 조항이 적용됩니다.</li>
            <li>⑥	전항에 따른 시행일 이후에 회원이 서비스를 이용한 경우에는 개정 약관에 동의한 것으로 간주합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-4">제 4 조 약관 외 준칙</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">본 약관에 명시되지 않은 사항에 대해서는 약관의 규제에 관한 법률, 전자금융거래법, 전기통신기본법, 전자상거래법, 독점 규제 및 공정거래에 관한 법률, 저작권법 등 관계법령 및 회사가 정한 서비스의 세부 이용지침, 전자금융거래약관 등의 규정에 따릅니다.</p>
        </div>
        <p class="tp-tit01">제 2 장 서비스 이용 계약</p>
        <p class="tp-tit02" id="tp-spec1-5">제 5 조 서비스 이용계약의 성립, 이용신청 및 승낙</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	이용계약은 회원이 되고자 하는 자가 본 약관의 내용 및 개인정보 처리방침에 대하여 동의를 한 후 이용신청을 할 경우 회사가 이를 승낙함으로써 체결됩니다.</li>
            <li>②	회원이 되고자 하는 자는 사이트에 가입 시 회사에서 제공하는 회원가입 신청양식에 따라 필요한 사항을 기재하여야 합니다. 회원가입 신청 시 일부 항목은 서비스 신청 시 반드시 입력해야 합니다.</li>
            <li>③	회사는 회원이 되고자 하는 자에게 사업자인증번호, 이메일, SMS 인증 또는 기타 본인을 확인할 수 있는 인증절차를 요구할 수 있습니다. 이 경우 회원이 되고자 하는 자는 해당 인증을 수행하는 등 가입절차를 완료하여야 합니다.</li>
            <li>④	이용신청을 완료한 자는 다음 각호의 서류를 직접, 팩스나 우편발송, 사업자인증서비스 등 회사가 인정하는 방법으로 제출하여야 합니다.
              <ol class="ol-list pl11">
                <li>1. 사업자등록증</li>
                <li>2. 기타 회사가 필요하다고 인정하여 요청하는 자료</li>
              </ol>
            </li>
            <li>⑤	회사는 다음의 각 호에 해당하는 회원 가입 신청에 대하여는 승낙을 제한할 수 있으며, 이 사유가 해소될 때까지 승낙을 유보하거나 승낙한 이후에도 이용계약을 해지하거나 서비스 전부 또는 일부의 이용을 제한할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 기술상 서비스 제공이 불가능하거나 서비스 관련 설비 용량이 부족한 경우</li>
                <li>2. 실명이 아니거나, 다른 사람의 명의사용 등 이용자 등록 시 허위로 신청하는 경우</li>
                <li>3. 이용자 등록 사항을 누락하거나 오기하여 신청하는 경우</li>
                <li>4. 14세 미만 아동(유료서비스는 만19세 미만인 자 포함)이 법정대리인(부모 등)의 동의를 얻지 아니한 경우</li>
                <li>5. 이용자의 상품 구매 목적을 포함한 서비스 이용 목적이 명백하게 사회 질서 및 미풍양속에 반하는 경우</li>
                <li>6. 서비스 이용목적 또는 이용행위가 법령에 위반되거나 제3자의 권리를 침해할 우려가 있는 경우</li>
                <li>7. 특정금융정보법에 따른 고객확인이 이행되지 않거나, 의심거래가 발생하는 경우와 악성 프로그램 및 버그 이용 또는 시스템 취약점을 악용하는 등 부정한 방법을 서비스에 사용한 경우</li>
                <li>8. 이용자가 본 약관에 의하여 회원 자격을 상실한 적이 있는 경우. 다만, 회사가 승낙한 경우는 예외로 함</li>
                <li>9. 회사의 서비스 정책 또는 본 이용약관에 위반하여 서비스를 이용하고자 하는 경우</li>
                <li>10.	기타 회사가 정한 이용신청 요건이 만족되지 않았을 경우</li>
              </ol>
            </li>
            <li>⑥	회사는 서비스를 이용한 사실을 게재하기 위해 “회원”의 브랜드 로고, CI 등을 사이트에 게시할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-6">제 6 조 서비스 이용 제한 또는 정지 및 자격상실</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원이 다음 각 호의 사유에 해당하거나 본 약관상의 의무를 이행하지 않은 경우, 회사는 회원 자격을 제한 또는 정지시킬 수 있으며, 회원은 회사에게 제한 또는 정지에 따른 보상을 청구할 수 없습니다. 다만, 회사의 귀책이 경합한 경우 민법 등 관계법령에 따라 책임을 부담합니다.
              <ol class="ol-list pl11">
                <li>1. 전기통신기본법, 전자상거래법, 전자금융거래법, 특정금융정보법, 정보통신윤리위원회 심의규정, 정보통신윤리강령 및 기타 관련 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하는 경우</li>
                <li>2. 방송통신위원회 또는 한국인터넷진흥원 등이 불법스팸 전송사실을 확인하여 이용정지를 요청하는 경우</li>
                <li>3. 제15조 이용자의 의무 중 하나 또는 그 이상을 위반하는 경우</li>
                <li>4. 본 사이트에서 판매하는 상품(기업에서 프로모션이나 이벤트를 위한 용도로 할인 구매하는 기간한정 B2B상품)을 회원 개인의 이익을 위한 목적으로 구매하는 경우</li>
                <li>5. 회사의 자금세탁방지 및 공중협박자금조달 금지에 관한 업무규정에 위배되는 행위가 있는 경우</li>
              </ol>
            </li>
            <li>②	회원이 다음 각 호의 사유에 해당하거나 회원의 자격을 제한 또는 정지시킨 후 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우에 회사는 해당 회원의 자격을 상실시킬 수 있으며, 회원은 회사에게 자격 상실에 따른 보상을 청구할 수 없습니다. 다만, 회사의 귀책이 경합한 경우 민법 등 관계법령에 따라 책임을 부담합니다.
              <ol class="ol-list pl11">
                <li>1. 회원의 계정, 명의를 도용하거나 결제 도용한 경우</li>
                <li>2. 해킹 및 악성프로그램을 배포하는 경우</li>
                <li>3. 서비스를 통해 할인 구매한 모바일 쿠폰 을 오픈마켓이나 다른 판매 사이트를 통해 재판매 하는 경우</li>
                <li>4. 동일 수신번호로 모바일 쿠폰을 중복, 지속적으로 수신 받는 등 부정 사용의 우려가 있는 경우</li>
                <li>5. 부정결제가 의심되는 경우</li>
                <li>6. 사전 동의 없이 서비스를 도용(쿠폰/바코드 이미지 무단변경, 자체 이미지 제작, 유효기간 임의 조정 등)하는 경우</li>
                <li>7. 발송된 모바일 쿠폰을 임의로 변경하여 사용하거나(인쇄, 출력 등) 이용하는 경우</li>
                <li>8. 이용자가 서비스의 정상적인 제공을 저해하거나 다른 회원의 서비스 이용에 지장을 줄 것으로 예상되는 경우</li>
                <li>9. 회사가 의도하지 않은 방법으로 서비스를 이용하는 경우</li>
                <li>10.	사업자 정보를 도용하여 회원가입 또는 결제 등의 행위를 하는 경우</li>
                <li>11.	회원이 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 경우</li>
              </ol>
            </li>
            <li>③	회원은 본 조의 회사 조치에 대하여 회사가 정한 절차에 따라 이의신청을 할 수 있으며, 회원의 이의가 정당하다고 회사가 인정하는 경우 회사는 즉시 서비스의 이용을 재개합니다.</li>
            <li>④	일부 상품의 경우 회사가 정한 정책(회원등급, 사업자기준 등)에 따라 구매가 제한될 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit01">제 3 장 서비스 이용</p>
        <p class="tp-tit02" id="tp-spec1-7">제 7 조 서비스의 이용시간</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	서비스의 이용은 연중무휴 1일 24시간을 원칙으로 합니다.</li>
            <li>②	제1항에도 불구하고 회사의 업무상이나 기술상의 이유로 서비스가 일시 중지될 수 있고, 또한 운영 상의 목적으로 회사가 정한 기간에는 서비스가 일시 중지될 수 있습니다. 이러한 경우 회사는 사전에 이를 공지하며, 부득이한 경우 사후 통보 또는 공지할 수 있습니다.</li>
            <li>③	회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용 가능한 시간을 별도로 정할 수 있으며 이 경우 그 내용을 공지합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-8">제 8 조 서비스의 변경 및 중단</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 변경될 서비스의 내용 및 제공일자를 본 약관에서 정한 방법으로 회원에게 통지하고 서비스를 변경하여 제공할 수 있습니다.</li>
            <li>②	회사는 다음 각 호에 해당하는 경우 서비스의 전부 또는 일부 제한하거나 서비스 제공을 중단할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 서비스용 설비의 보수 등 공사로 인한 부득이한 경우</li>
                <li>2. 시스템 오류 등으로 재고가 없는 상품에 대한 구매가 발생하였거나 현저한 가격 변동 등으로 구매 신청 가격으로 상품 공급이 불가능한 경우</li>
                <li>3. 구매 신청 내용에 허위, 기재누락, 오기가 있는 경우</li>
                <li>4. 이용자가 회사의 영업활동을 방해하는 경우</li>
                <li>5. 회원이 본 약관을 위반한 경우</li>
                <li>6. 정전, 제반 설비의 장애 또는 이용량의 폭주 등으로 정상적인 서비스 제공에 지장이 있는 경우</li>
                <li>7. 상품 공급사와의 계약 종료 등과 같은 회사의 제반 사정으로 서비스를 유지할 수 없는 경우</li>
                <li>8. 천재지변, 국가비상사태 등 불가항력적 사유가 있는 경우</li>
                <li>9. 기타 서비스를 유지할 수 없는 중대한 사유가 발생한 경우</li>
              </ol>
            </li>
            <li>③	본 조 제2항의 서비스 중단으로 인하여 발생한 회원의 손해에 대하여 회사는 책임을 부담하지 않습니다. 다만, 회사의 귀책이 경합한 경우 민법 등 관계법령에 따라 책임을 부담합니다.</li>
            <li>④	회사가 통제할 수 없는 사유로 인한 서비스의 중단(회사의 고의, 과실이 없는 디스크 장애, 시스템다운 등)으로 인하여 사전 통지가 불가능한 경우에는 사후통지 하거나 통지가 이루어지지 않을 수 있습니다</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-9">제 9 조 지적재산권 관련 법령의 준수</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원은 지적재산권(상표권, 저작권을 포함하며 이에 한정되지 않습니다) 관련 규정을 준수해야 합니다. 만약 회원이 제공한 저작물로 인하여 제3자의 지적재산권 침해가 발생한 경우 민형사상 모든 책임은 회원 당사자에게 있으며 회사는 어떠한 책임도 지지 않습니다. 다만, 회사의 고의 및 중과실이 있는 경우에는 면책되지 않습니다.</li>
            <li>②	회원이 제1항의 위반행위를 함에 따라 손해를 입은 다른 이용자 또는 제3자가 회사를 상대로 손해배상을 청구하는 경우, 약관을 위반한 이용자는 자신의 비용과 노력을 들여 회사를 면책시켜야 하며, 회사에 실제로 손해가 발생한 경우 회사는 그 손해 상당액을 해당 이용자에게 구상할 수 있습니다</li>
            <li>③	회원은 서비스를 이용함으로써 얻은 정보를 복제, 송신, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안됩니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-10">제 10 조 회원등급 산정</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원등급에 반영되는 누적 주문 금액은 회원별 등급에 따른 할인율을 적용한 최종결제금액으로 산정됩니다.</li>
            <li>②	회원이 모바일 쿠폰의 예약발송을 요청하는 경우 주문 시점의 회원등급별 할인율이 적용됩니다.</li>
            <li>③	회원이 본 약관 또는 개별 서비스 약관을 위반한 경우 회사는 회원에게 고지함과 동시에 회원등급을 강제로 조정할 수 있습니다.</li>
            <li>④	회원등급 선정 기준은 매년 변경될 수 있습니다. 회원등급에 따른 혜택이 상향되는 경우 회사는 사이트 공지 또는 이메일 등의 방법으로 관련 내용을 사전 안내 후 적용합니다. 회원등급 혜택이 하향되는 경우에는 사이트 내 동의 절차를 통하여 변경 기준 및 내용을 안내하고 회원의 동의를 받은 후 적용합니다.</li>
            <li>⑤	회원등급에 따른 할인율, 회원등급 조정 등에 관한 자세한 내용은 사이트 등을 통하여 게시합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-11">제 11 조 H캐시 이용</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	H캐시는 회사가 발행하여 회사가 운영하는 Hcon에서만 사용이 가능한 전자적 지급수단을 말하며 회원은 신용카드, 계좌이체 등의 결제를 통해 충전할 수 있습니다.</li>
            <li>②	회원이 H캐시를 구매하고 결제를 취소를 하는 경우 회사는 취소한 대금을 원 결제수단으로 해당 회원에게 환불합니다.</li>
            <li>③ H캐시와 관련하여 회원탈퇴로 인하여 정보 확인이 불가능하거나 회원의 정보(사업자정보, 계좌번호 등) 오기입 등 회원의 귀책사유로 인해 발생하는 불이익에 대해서 회사는 책임을 지지 않습니다.</li>
            <li>④	H캐시를 사용하는 경우 차감 순서는 선 충전/적립된 H캐시부터 차감됩니다.</li>
            <li>⑤	본 약관에서 정하지 않는 H캐시 사용에 관한 상세한 사항은 회사 정책에 따르며, 회사가 운영하는 웹사이트 등을 통하여 이를 회원에게 안내합니다.</li>
            <li>⑥	다음 각 호의 경우, H캐시가 소멸됩니다.
              <ol class="ol-list pl11">
                <li>1. H캐시는 충전(적립)일로부터 5년이 경과하면 상법상의 채권소멸시효가 완성되어 충전(적립)된 시점을 기준으로 5년이 경과된 H캐시는 자동 소멸되며, 회사에 재화 등의 제공, 환불 및 잔액 반환을 요청할 수 없습니다.</li>
                <li>2. H캐시 유효기간이 소멸하기 30일 전 회사는 회원에게 H캐시 소멸 알림톡을 발송하고, 약관에서 정한 소멸일자에 따라 H캐시는 소멸됩니다.</li>
                <li>3. 회원 탈퇴 시, 잔여 H캐시가 있는 경우, 회사는 환불접수를 받아야 하며 회원 탈퇴 이전에 환불처리가 완료되어야 합니다. </li>
              </ol>
            </li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-12">제 12 조 H캐시의 충전취소 및 환불</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원이 충전일로부터 7일 이내에 미사용된 H캐시의 충전취소를 원할 경우 하기의 경우에 회사에 신청하여 충전을 취소할 수 있습니다. 이때 충전취소는 원 결제수단으로 진행됩니다. 다만, 회사로부터 무상 제공받은 H캐시의 경우 환불 대상에서 제외됩니다.</li>
            <li>②	회원이 충전일로부터 7일이 경과되었거나, 일부 사용된 H캐시에 대해 환불을 요청하는 경우, 회사는 회원에게 환불금액의 일정률을 환불수수료로 청구하여 해당 금액을 제외한 금액에 대해 환불 처리를 진행합니다.</li>
            <li>③	회사는 다음 각 호의 어느 하나에 해당하는 경우에는 회원에게 H캐시 전액을 환불합니다.
              <ol class="ol-list pl11">
                <li>1. 천재지변 등의 사유로 H캐시를 사용하지 못하게 된 경우</li>
                <li>2. H캐시의 결함으로 Hcon에서 서비스를 제공하지 못하는 경우</li>
              </ol>
            </li>
            <li>④	회원의 환불요청에도 불구하고 다음 각호의 어느 하나에 해당하는 경우, 환불이 보류됩니다.
              <ol class="ol-list pl11">
                <li>1. 회원의 사업자정보(상호명 또는 대표자명 등)가 환불받을 계좌의 예금주 정보와 상이할 경우</li>
                <li>2. 개인정보 도용 및 결제정보 도용 또는 부정결제 등으로 인한 경우</li>
                <li>3. 회원이 지정한 은행계좌의 문제 등으로 계좌이체에 실패하는 경우</li>
                <li>4. 회원의 H캐시 잔액이 환불 수수료 보다 적을 경우</li>
                <li>5. 회원의 H캐시 잔액이 회원의 환불요청 금액 보다 적은 경우</li>
              </ol>
            </li>
            <li>⑤	전항의 각호의 사유로 인해 환불이 보류되는 경우, 회사는 각호의 사유가 발생하였음을 인지한 날로부터 14일 내에 환불의 보류 사실 및 그 이유를 회원에게 통지합니다.</li>
            <li>⑥	회원이 본 조 제 4항의 각호의 사유가 해소되었음을 입증하는 경우 회사는 즉시 회원에게 환불 요청 금액을 환불합니다.</li>
          </ol>
          <p class="tp-cont-txt">본 약관의 개정에 따른 회원탈퇴 또는 회원이 본 약관을 위반하여 서비스 이용이 정지되었을 경우에는 환불수수료가 공제되지 않습니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-13">제 13 조 결제 수단</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	사이트에서 모바일 쿠폰을 구매하기 위한 대금 결제 수단은 다음 각호의 방법 중 가용한 방법으로 할 수 있습니다.
              <ol class="ol-list pl11">
                <li>1. 선불카드, 직불카드, 신용카드 등의 각종 카드결제</li>
                <li>2. 폰뱅킹, 인터넷뱅킹 등의 각종 계좌이체</li>
                <li>3. H캐시</li>
                <li>4. 적립금</li>
              </ol>
            </li>
            <li>②	제1항의 결제 수단을 사용할 경우 회사는 사전에 회원의 특수 산업 및 지불 역량 확인을 위한 각종 증빙을 요구할 수 있으며 회원이 이를 거부할 시 회사는 회원과의 거래진행을 중지하거나 해당 거래를 취소할 수 있습니다.</li>
            <li>③	회원은 제1항의 결제 수단을 사용함에 있어 반드시 회원 명의의 결제 수단을 사용하여야 하며, 타인의 결제 수단을 임의로 사용하여서는 안됩니다. 타인의 결제 수단을 임의 사용함으로써 발생하는 결제 수단의 적법한 소유자, 결제 관련 제3자의 손실과 손해에 대한 책임은 회원에게 있습니다.</li>
            <li>④	상품 등의 구매대금의 결제와 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 회원이 부담하여야 합니다. 다만, 회사의 귀책이 경합한 경우 민법 등 관계법령에 따라 책임을 부담합니다.</li>
            <li>⑤	회원은 구매대금 결제 시 정당하고, 적법한 사용권한을 가지고 있는 결제 수단을 사용하여야 하며, 회사는 그 여부를 확인할 수 있습니다. 또한 회사는 회원 결제 수단의 적법성 등에 대한 확인이 완료될 때까지 거래진행을 중지하거나 해당 거래를 취소할 수 있습니다.</li>
            <li>⑥	회사의 정책 및 제1항의 결제업체(이동통신사, 카드사 등)의 기준에 따라 회원의 당월 누적 결제액이 제한될 수 있습니다. 해당 기준을 초과한 경우 상품 등의 구매가 불가능할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-14">제 14 조 회사의 의무</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 관련법과 본 약관이 금지하거나 공서양속에 반하는 행위를 하지 않으며, 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다하여야 합니다.</li>
            <li>②	회사는 회원이 안전하게 서비스를 이용할 수 있도록 개인정보(신용정보 포함)보호를 위해 보안시스템을 갖추어야 하며 개인정보처리방침을 공시하고 준수합니다.</li>
            <li>③	회사는 상품이나 용역에 대하여 표시광고의 공정화에 관한 법률에 따른 부당한 표시광고행위를 함으로써 회원이 손해를 입은 때에는 이를 배상할 책임을 집니다. 또한, 회사는 회원이 원하지 않는 영리목적의 광고성 전자우편을 발송하지 않습니다.</li>
            <li>④	회사는 서비스와 관련한 이용자의 불만사항이 접수되는 경우 이를 최대한 신속하게 처리하여야 하며, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 서비스 화면에 게재하거나 SMS 등을 통하여 이용자에게 통지합니다.</li>
            <li>⑤	회사는 이용자에게 제공하기로 한 상품의 품절 또는 기술적 사양의 변경이 있는 경우 그 사유를 구매자에게 통지 가능한 주소(“회사”와 미리 약정하여 지정한 연락처, 메일 등 연락 가능한 수단을 포함)로 즉시 통지합니다. 또한, 재화 등의 대금을 받은 경우에는 대금을 받은 날부터 2영업일 이내에 환급하거나, 환급에 필요한 조치를 취하며 휴대폰 결제 등 통신사 휴대폰 결제의 경우 특성에 따라 환급을 위해 필요한 필수정보제공을 요청할 수 있습니다.</li>
            <li>⑥	회사가 제공하는 서비스로 인하여 이용자에게 손해가 발생한 경우, 해당 손해가 회사의 고의나 중과실에 의해 발생한 경우에 한하여 회사가 책임을 부담합니다.</li>
            <li>⑦	회사는 서비스 제공과 관련하여 취득한 회원의 개인정보를 본인의 동의 없이 타인에게 누설하거나 배포할 수 없으며 서비스 관련 업무 이외의 목적으로는 사용할 수 없습니다. 단, 다음 각 호에 해당하는 경우에는 예외로 합니다.
              <ol class="ol-list pl11">
                <li>1. 전기통신기본법, 소비자기본법, 형사소송법 등 법률의 규정에 의해 국가기관의 적법한 절차에 의한 요구가 있는 경우</li>
                <li>2. 범죄에 대한 수사상의 목적으로 유관기관의 요청이 있는 경우</li>
                <li>3. 다른 법률에 특별한 규정이 있는 경우</li>
              </ol>
            </li>
            <li>⑧	회사는 서비스 제공 목적에 맞는 서비스 이용 여부를 확인하기 위하여 상시적으로 모니터링을 실시합니다.</li>
            <li>⑨	회사는 판매되는 상품의 모든 가격 정보가 정확히 유지되도록 노력합니다. 그럼에도 오류(오타나 그와 유사한 실수)로 인해 페이지에 표시된 가격이 상품의 정상가격과 다른 경우 회사는 기존 주문을 취소하고 정상가격으로 새로 주문을 할 것인지 고객에게 고지 및 문의하거나, 고객의 주문을 승낙하지 않을 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-15">제 15 조 회원의 의무</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원은  회원이 제공(발송/구매)한 상품으로 인해 접수되는 수신자 및 이용자의 문의 및 클레임을 직접 처리합니다.</li>
            <li>②	회원은 다음 각 호의 행위를 하여서는 안됩니다.
              <ol class="ol-list pl11">
                <li>1. 서비스를 제공받기 위해 이용 신청 또는 변경 시 허위 사실을 기재하거나, 다른 회원의 정보를 도용, 부정하게 사용하는 행위</li>
                <li>2. 회사의 서비스 정보를 이용하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위</li>
                <li>3. 서비스를 통해 구입한 재화 등의 대금, 기타 서비스 이용에 관련하여 회원이 부담하는 채무를 기일에 지급하지 않는 경우</li>
                <li>4. 본 사이트를 통해 구매한 상품을 제3자에게 판매, 임대 등을 하여 이득을 취득하는 일체의 제공 행위</li>
                <li>5. 타인의 명예를 손상시키거나 불이익을 주는 행위, 타인으로 가장하는 행위 및 타인과의 관계를 허위로 명시하는 행위</li>
                <li>6. 이유 없는 잦은 연락, 소란 또는 협박, 인과관계가 없는 피해에 대한 보상(H캐시, 현금, 상품)요구 등으로 업무를 방해하는 경우</li>
                <li>7. 이유 없는 취소/반품 또는 기타 행위 등의 방법으로 부당하게 이득을 취한 경우</li>
                <li>8. 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 행위</li>
                <li>9. 공공질서 및 미풍양속에 위반되는 내용 등을 타인에게 유포하는 행위</li>
                <li>10.	서비스 운영을 고의로 방해하거나 서비스의 안정적 운영을 방해할 수 있는 정보 및 수신자의 명시적인 수신거부의사에 반하여 광고성 정보를 전송하는 행위</li>
                <li>11.	서비스에 게시된 정보를 변경하는 행위</li>
                <li>12.	관련 법령에 의하여 전송 또는 게시가 금지되는 정보 (컴퓨터 프로그램 포함)의 전송 또는 게시 행위</li>
                <li>13.	회사의 직원이나 서비스 운영자를 가장하거나 사칭하여 SMS, MMS 발송 또는 연락을 취하는 행위</li>
                <li>14.	스토킹(Stalking) 등 다른 회원을 괴롭히는 행위 등 기타 불법적이거나 부당한 행위</li>
                <li>15.	서비스를 통해 구매한 상품을 오픈마켓이나 다른 판매 사이트를 통해 재판매 하는 행위</li>
                <li>16.	동일 수신자번호로 모바일쿠폰을 중복, 지속적으로 수신 받는 등 부정 사용할 우려 등이 있는 행위</li>
                <li>17.	불법스팸을 전송하는 행위</li>
                <li>18.	서비스를 부정한 결제방식으로 사용하는 행위</li>
                <li>19.	본 약관에 따라 회사와 합의된 서비스 이용 목적 이외로 사용하는 행위</li>
                <li>20.	제1호 내지 제20호에 준하는 사유로서 불법적이거나 부당한 행위</li>
              </ol>
            </li>
            <li>③	회원은 관계 법령, 본 약관의 규정, 이용안내 및 사이트상에 공지한 주의사항, 회사가 통지하는 사항 등을 준수하여야 하며, 기타 회사의 업무에 방해되는 행위를 하여서는 안됩니다.</li>
            <li>④	회원이 본 조의 의무에 위반하여 발생한 영업 활동의 결과 및 손실, 관계기관에 의한 구속 등 법적 조치 등에 관해서는 회사의 고의 또는 과실이 없는 한 회사가 책임을 지지 않습니다.</li>
            <li>⑤	회원이 본 조의 의무를 위반하는 경우에 회원에게 고지함과 동시에 회사는 모바일 쿠폰의 이용을 제한할 수 있습니다.</li>
            <li>⑥	회원은 구매약정동의서에 동의 및 거부할 수 있는 권리가 있으며, 거부 시 상품 구매가 불가합니다. 동의 시에는 약정서에 명시된 정책을 따릅니다.</li>
            <li>⑦	회원은 회사가 제공하는 서비스의 상세 내용과 거래의 조건을 정확하게 확인한 후 상품 구매를 신청하여야 합니다. 구매하려는 상품의 상세내용과 거래의 조건을 확인하지 않고 구매하여 발생하는 손해에 대하여 회사의 고의나 과실이 없는 한 회원이 책임을 부담합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-16">제 16 조 회원정보의 변경</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원은 회원 정보관리화면을 통하여 언제든지 회원정보를 열람하고 수정할 수 있습니다. 다만 서비스 운영을 위하여 회사가 정한 일부 사항은 수정이 제한될 수 있습니다.</li>
            <li>②	회원은 이용 신청 시 기재한 사항이 변경되었을 경우 즉시 온라인으로 수정을 하거나 회사가 정한 이용방법(1:1문의, 고객센터)으로 변경사항을 알려야 하며, 변경사항을 알리지 아니하여 발생한 손해에 대하여 회사는 책임지지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-17">제 17 조 아이디와 비밀번호 관리에 대한 의무와 책임</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원은 Hcon의 개인정보 관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 아이디(ID) 등은 수정이 불가능합니다.</li>
            <li>②	회원은 개인정보가 변경되었을 경우 Hcon몰 사이트에서 직접 수정 하셔야 합니다. 또한, Hcon몰의 개인정보 관리 책임자 또는 담당자에게 연락하여 정정을 요청하시면 지체 없이 조치하겠습니다.</li>
            <li>③	제2항의 변경사항을 수정하지 않음으로써 발생한 회원의 불이익 또는 제3자의 손해에 대하여 회원이 부담하며 회사는 고의 또는 과실이 없는 경우 이에 대하여 책임지지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-18">제 18 조 계약해지</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원이 서비스 이용계약을 해지하고자 할 경우에는 웹사이트에서 또는 회사가 정한 별도의 이용방법으로 회사에 해지 신청을 하여야 합니다. </li>
            <li>②	회사는 회원의 해지 신청 시 관련법 등이 정하는 바에 따라 이를 즉시 처리하여야 합니다.</li>
            <li>③	회원이 계약을 해지하는 경우, 회원의 아이디는 삭제되며 복구가 불가합니다.</li>
            <li>④	회원이 계약을 해지하는 경우, 회원의 주문 정보 등 회원이 생성한 데이터는 회사의 개인정보처리방침 및 관계 법령에 따라 별도로 분리 보관된 후 삭제됩니다.</li>
            <li>⑤	회사는 회원이 본 약관 상 의무를 위반한 경우 계약을 해지할 수 있습니다.</li>
            <li>⑥	회사는 회원이 서비스를 악용하여 스미싱, 사기 등 기타 부정거래를 한 사실을 발견한 경우 계약을 해지하며, 해당 회원은 향후 재가입이 제한됩니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-19">제 19 조 회원에 대한 통지</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회원의 사이트 이용에 필요한 권리 및 의무 사항을 회원이 지정한 이메일, SMS 등으로 통지할 수 있습니다. 단, E-mail, SMS 등을 통한 개별통지가 불가한 경우 사이트 공지로 갈음할 수 있으며, 회사에게 귀책이 없는 경우에는 이 때문에 발생하는 문제에 대해서 회사는 책임을 지지 않으며, 회사의 통지는 부가통신사업자 또는 수신인이 관리하는 메일서버 등에 도착하여 회원이 검색할 수 있는 상태에 이르렀을 때 도달된 것으로 봅니다.</li>
            <li>②	회사는 불특정 다수 회원에 대한 통지의 경우  1주일 이상 사이트 게시판 등에 게시함으로써 통지한 것으로 갈음할 수 있습니다. 단, 회원의 권리 또는 의무에 중대한 영향을 미치는 사안에 대해서는 개별 통지합니다.</li>
            <li>③	회사는 회원의 귀책사유로 인해 노출된 정보에 대해서는 회사의 고의 또는 과실이 없는 한 일체의 책임을 지지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-20">제 20 조 수신확인통지 구매신청 변경 및 취소</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회원의 구매신청이 있는 경우 회원에게 수신확인 통지를 합니다.</li>
            <li>②	수신확인통지를 받은 회원은 의사표시의 불일치 등이 있는 경우에는 수신확인 통지를 받은 후 즉시 구매신청 변경 및 취소를 요청할 수 있고, "회사"는 상품 제공 전에 회원의 요청이 있는 경우에는 지체 없이 그 요청에 따라 처리하여야 합니다. 다만, 이미 대금을 지불한 경우에는 본 약관의 청약철회 등에 관한 규정에 따릅니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-21">제 21 조 재화 등의 공급</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회원과 재화 등의 공급시기에 관하여 별도의 약정이 없는 이상 회원이 청약을 한 날로부터 7일이내에 재화 등을 제공 할 수 있도록 기타의 필요한 조치를 취합니다. 다만, 회사가 이미 재화 등의 대금의 전부 또는 일부를 받은 경우에는 대금의 전부 또는 일부를 받은 날부터 2영업일 이내에 조치를 취합니다. 이때 회사는 회원이 재화 등의 공급절차 및 진행사항을 확인할 수 있도록 적절한 조치를 합니다.</li>
            <li>②	회사는 회원이 구매한 재화 등에 대해 제공수단, 제공비용 부담자, 제공수단별 제공기간 등을 명시합니다. 만약 회사가 약정 제공기간을 초과한 경우에는 그로 인한 회원의 손해를 배상하여야 합니다. 다만, 회사가 고의ㆍ과실이 없음을 입증한 경우에는 그러하지 아니합니다.</li>
            <li>③	회사와 회원 간에 재화 등의 인도시기 또는 용역의 제공시기에 관하여 별도의 약정이 있는 경우에는 당해 약정이 본 약관에 우선합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-22">제 22 조 청약철회 등</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사와 상품 또는 용역 등의 구매에 관한 계약을 체결한 회원은 단순변심으로 인한 교환 및 반품의 경우 상품을 수령한 날로부터 7일 이내에 청약을 철회할 수 있습니다. 단, 개별 상품에 따라 환불 및 반품, 교환이 제한되는 경우가 있으며 이 경우 개별 상세페이지에 안내된 내용이 본 약관에 우선하여 적용됩니다. </li>
            <li>②	회원은 재화 등을 제공받는 경우 다음 각 호에 해당하는 경우에는 반품 및 교환을 할 수 없습니다.
              <ol class="ol-list pl11">
                <li>1. 회원의 귀책사유로 인한 상품 하자</li>
                <li>2. 회원의 사용 또는 일부 소비에 의하여 "재화 등"의 가치가 현저히 감소한 경우</li>
                <li>3. 시간의 경과에 의하여 재판매가 곤란할 정도로 "재화 등"의 가치가 현저히 감소한 경우</li>
                <li>4. 같은 성능을 지닌 재화 등으로 복제가 가능한 경우 그 원본인 재화 등의 포장을 훼손한 경우</li>
              </ol>
            </li>
            <li>③	제2항 제 2호 내지 4호의 경우 회사가 사전에 청약철회 등이 제한되는 사실을 회원이 쉽게 알 수 있는 곳에 명기하거나 시용상품을 제공하는 등의 조치를 하지 않았다면 회원의 청약철회 등이 제한되지 않습니다.</li>
            <li>④	회원은 제2항 및 제3항의 규정에도 불구하고 수령한 상품 또는 용역의 내용이 표시, 광고 내용과 다르거나, 계약 내용과 다르게 이행된 경우에는 공급받은 날로부터3개월 이내, 그 사실을 안 날 또는 알 수 있었던 날로부터30일 이내 청약철회 등을 할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-23">제 23 조 청약철회 등의 효과</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회원로부터 재화 등을 회수 받은 경우 3영업일 이내에 이미 지급받은 재화 등의 대금을 환급합니다. 이 경우 회사가 회원에게 재화 등의 환급을 지연한 때에는 그 지연기간에 대하여 「전자상거래 등에서의 소비자보호에 관한 법률 시행령」 법에서 정하는 지연이자율을 곱하여 산정한 지연이자를 지급합니다.</li>
            <li>②	회사는 위 대금을 환급함에 있어서 회원이 신용카드 또는 전자화폐 등의 결제수단으로 재화 등의 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 재화 등의 대금의 청구를 정지 또는 취소하도록 요청합니다.</li>
            <li>③	본 약관 또는 관련 법령에 따라 청약철회 등을 하는 경우 공급받은 재화 등의 반환에 필요한 비용은 회원이 부담합니다.</li>
            <li>④	회사는 회원에게 청약철회 등을 이유로 위약금 또는 손해배상을 청구하지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-24">제 24 조 모바일 쿠폰 주문취소 및 환불에 관한 특칙</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	구매자는 예약 발송되는 모바일 쿠폰 구매 시, 예약 발송을 요청한 시간으로부터 1시간 전까지만 주문취소가 가능합니다. </li>
            <li>②	다음 각호의 사유에 해당하는 경우 구매자는 상품 유효기간 내에 주문취소를 할 수 있고, 이 때 회사는 주문 시 사용한 원 결제수단으로 구매자에게 구매대금을 환불합니다. 이때, 주문 시 사용한 H캐시 또는 적립금의 유효기간이 만료된 경우 회사의 CS처리를 통해 적립금으로 환불이 진행됩니다.
              <ol class="ol-list pl11">
                <li>1. 모바일 쿠폰 전송 시 시스템 상 장애가 있거나 서비스되고 있지 않음으로 인해 영구적으로 수신자에게 모바일 쿠폰이 정상적으로 발송되지 않는 경우</li>
                <li>2. 주문 시 네트워크 문제로 인해 결제만 수행되고 정상적으로 모바일 쿠폰 발송 단계를 거치지 못 한 경우</li>
              </ol>
            </li>
            <li>③	모바일 쿠폰이 제휴처에서 교환된 이후에는 해당 모바일 쿠폰 및 해당 모바일 쿠폰이 포함된 주문 건에 대한 주문취소 및 환불이 되지 않습니다. 다만, 회원은 회사의 귀책사유로 인한 경우 회사는 주문취소를 할 수 있습니다. </li>
            <li>④	구매자가 수신자의 휴대전화번호를 잘못 입력하여 모바일 쿠폰이 오발송된 후 수신자에 의해 모바일 쿠폰이 교환된 경우 회사에서는 구매자의 오발송에 대해 책임지지 않습니다. 단, 모바일 쿠폰이 교환되기 전에 구매자는 수신자를 정정할 수 있습니다.</li>
            <li>⑤	수신자가 모바일 쿠폰을 유효기간 동안 해당 제휴처에서 사용하지 않는 경우 유효기간 이후 재사용 할 수 없으며 주문취소 및 환불이 되지 않습니다.</li>
            <li>⑥	회원이 본 약관에 따른 회원의 의무를 위반하는 경우 “회사”는 회원의 자격을 정지시키거나 결제된 상품의 일부 또는 전부에 대한 주문취소를 할 수 있습니다.</li>
          </ol>
        </div>
        <p class="tp-tit01">제 5 장 개인정보의 보호</p>
        <p class="tp-tit02" id="tp-spec1-25">제 25 조 회원의 개인정보보호</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회원의 개인정보 수집 시 서비스제공을 위하여 필요한 범위에서 최소한의 개인정보를 수집합니다.</li>
            <li>②	회사는 회원가입 시 서비스 이용에 필요한 정보를 미리 수집하지 않습니다. 다만, 관련 법령에서 달리 정함이 있는 경우에는 예외로 합니다.</li>
            <li>③	회사는 회원의 개인정보를 수집•이용하는 때에는 당해 회원에게 그 목적을 고지하고 동의를 받습니다.</li>
            <li>④	회사는 수집된 개인정보를 목적 외의 용도로 이용할 수 없으며, 새로운 이용목적이 발생한 경우 또는 제3자에게 제공하는 경우에는 이용•제공 단계에서 당해 회원에게 그 목적을 고지하고 동의를 받습니다.<br />다만, 관련 법령에 달리 정함이 있는 경우에는 예외로 합니다.</li>
            <li>⑤	회사가 제3항과 제4항에 의해 회원의 동의를 받아야 하는 경우 관련법령에 정하고 있는 사항을 미리 명시하거나 고지해야 하며 회원은 언제든지 이 동의를 철회할 수 있습니다.</li>
            <li>⑥	회원은 언제든지 회사가 가지고 있는 자신의 개인정보에 대해 열람 및 오류정정을 요구할 수 있으며 회사는 이에 대해 지체 없이 필요한 조치를 취할 의무를 집니다. 회원이 오류의 정정을 요구한 경우에는 회사는 그 오류를 정정할 때까지 당해 개인정보를 이용하지 않습니다.</li>
            <li>⑦	회사는 개인정보 보호를 위하여 회원의 개인정보를 취급하는 자를 최소한으로 제한하여야 하며 회원의 개인정보가 분실, 도난, 유출, 변조 등으로 회원에 손해가 발생한 경우 회원은 회사에 대하여 손해배상을 청구할 수 있습니다. 단, 회사가 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
            <li>⑧	회사 또는 그로부터 개인정보를 제공받은 제3자는 개인정보의 수집목적 또는 제공받은 목적을 달성한 때에는 당해 개인정보를 지체 없이 파기합니다.</li>
            <li>⑨	회사는 개인정보의 수집•이용•제공에 관한 동의 란을 미리 선택한 것으로 설정해두지 않습니다. 또한 개인정보의 수집•이용•제공에 관한 회원의 동의 거절 시 제한되는 서비스를 구체적으로 명시하고, 필수수집항목이 아닌 개인정보의 수집•이용•제공에 관한 회원의 동의 거절을 이유로 회원가입 등 서비스 제공을 제한하거나 거절하지 않습니다.</li>
            <li>⑩	기타 개인정보 처리와 관련한 내용은 개인정보처리방침에 고지합니다. </li>
          </ol>
        </div>
        <p class="tp-tit01">제 6 장 손해배상 등</p>
        <p class="tp-tit02" id="tp-spec1-26">제 26 조 손해 배상</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회원이 본 약관의 규정을 위반함으로 인하여 발생하는 모든 문제는 회원에게 책임이 있습니다. 회원은 이로 인해 발생한 회사, 수신자 또는 제3자의 손해에 대하여 손해액 전액을 배상하여야 합니다.</li>
            <li>②	회원이 서비스를 이용함에 있어 행한 불법행위나 본 약관 위반행위를 하여 회사가 당해 회원 이외의 제3자로부터 손해배상 청구 또는 소송을 비롯한 각종 이의제기를 받는 경우 당해 회원은 자신의 책임과 비용으로 회사를 면책시켜야 하며, 회사가 면책되지 못한 경우 당해 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-27">제 27 조 서비스의 제공</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 Hcon으로 다음과 같은 업무를 수행합니다.
              <ol class="ol-list pl11">
                <li>1. 재화 또는 용역에 대한 정보 제공 및 제공 계약의 체결</li>
                <li>2. 구매계약이 체결된 재화 또는 용역의 제공</li>
                <li>3. 기타 회사가 정하는 업무</li>
              </ol>
            </li>
            <li>②	회사는 재화 등의 품절 또는 기술적 사양의 변경 등의 경우에는 장차 체결되는 계약에 의해 제공할 재화•용역의 내용을 변경할 수 있습니다. 이 경우에는 변경된 재화•용역의 내용 및 제공일자를 명시하여 현재의 재화•용역의 내용을 게시한 곳에 즉시 공지합니다.</li>
            <li>③	회사는 제공하기로 회원과 계약을 체결한 서비스의 내용을 재화 등의 품절 또는 기술적 사양의 변경 등의 사유로 변경할 경우 그 사유를 회원에게 통지 가능한 주소로 즉시 통지합니다. 이 경우 회사는 이로 인하여 회원이 입은 손해를 배상합니다. 단, 회사의 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.</li>
            <li>④	회사는 서비스를 일정범위로 분할하여 각 범위 별로 이용가능시간을 별도로 지정할 수 있습니다. 다만, 이러한 경우에는 그 내용을 사전에 공지합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-28">제 28 조 양도금지</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">회원은 서비스의 이용권한, 기타 이용 계약상 지위를 타인에게 양도, 증여, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</p>
        </div>
        <p class="tp-tit02" id="tp-spec1-29">제 29 조 면책사항</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>①	회사는 회사의 과실 없이 이용자에게 발생된 다음 각호의 사유로 인한 손해에 대해서 책임을 지지 않습니다.
              <ol class="ol-list pl11">
                <li>1. 국가의 비상사태, 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우</li>
                <li>2. 회원이 타인의 휴대전화(분실 휴대전화 포함)를 이용하거나 번호를 도용하여 모바일 쿠폰을 구매한 경우</li>
                <li>3. 회원이 수신자의 번호를 잘못 입력하여 모바일 쿠폰을 전송하였는데, 수신자가 모바일 쿠폰을 이미 사용하였거나 반환을 거절하는 경우</li>
                <li>4. 회원이 모바일 쿠폰을 불법 할인의 목적으로 구매하여 제3자 또는 수신자에게 전송(판매)하는 경우</li>
                <li>5. 서비스의 효율적인 제공을 위한 시스템 개선, 장비 증설 등 계획된 서비스 중지 일정을 사전에 공지한 경우</li>
                <li>6. 회사에게 회선, 통신망, 전용선을 제공하고 있는 이동통신사 또는 부가통신사업자 측의 장애귀책사유로 인한 경우</li>
              </ol>
            </li>
            <li>②	회사는 회원이 서비스를 이용하여 기대하는 수익을 얻지 못하거나 상실한 것에 대한 책임을 지지 않습니다.</li>
            <li>③	회사는 회사의 귀책사유가 없는 한 회원이 서비스를 이용하면서 얻은 자료로 인한 손해에 대하여 책임을 지지 않습니다.</li>
            <li>④	회사는 회원이 생성한 데이터 내용을 확인할 의무가 없으며 데이터 내용으로 인하여 발생하는 불법 사항이나 개인간의 분쟁 등에 대하여 회사는 한 책임을 지지 않습니다.</li>
            <li>⑤	회사는 서비스 이용의 장애로 인하여 발생한 회원의 부가적, 영업적인 손해에 대해서는 책임을 면합니다.</li>
            <li>⑥	회사는 회사의 귀책사유가 없는 한 회원이 게시 또는 전송한 자료의 내용에 대해서는 책임을 면합니다.</li>
            <li>⑦	회사는 회사의 귀책사유가 없는 한 회원 상호 간 또는 회원과 제3자 상호 간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임을 면합니다.</li>
            <li>⑧	회사는 무료로 제공하는 서비스 이용과 관련하여 회사의 귀책사유가 없는 한 책임을 면합니다.</li>
            <li>⑨	회원은 인사이동, 퇴직 등으로 인하여 소속 임직원이 더 이상 "서비스"를 이용할 권한이 없는 경우, 회원 아이디의 접근권한을 지체없이 변경 또는 말소해야 하며, 회사는 회사의 귀책사유가 없는 한 회원이 아이디 관리를 소홀히 하여 발생하는 손해에 대하여 책임을 지지 않습니다.</li>
            <li>⑩	회사는 타사가 발행한 모바일 쿠폰으로 인한 분쟁과 관련하여 전자금융거래법에 따른 발행자의 의무에 대해서는 회사의 귀책사유가 없는 한 책임을 지지 않습니다.</li>
          </ol>
        </div>
        <p class="tp-tit02" id="tp-spec1-30">제 30 조 관할법원 등</p>
        <div class="tp-cont">
          <ol class="ol-list">
            <li>① 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 이용자는 분쟁의 해결을 위해 성실히 협의합니다.</li>
            <li>② 본 조 제1항의 협의에서도 분쟁이 해결되지 않을 경우 양 당사자는 민사소송법상의 관할법원에 소를 제기할 수 있습니다.</li>
            <li>③ 서비스 이용 및 본 약관과 관련하여 발생하는 분쟁에 대해서는 대한민국의 법률을 적용합니다.</li>
          </ol>
        </div>
        <p class="tp-tit02">부 칙</p>
        <div class="tp-cont">
          <p class="tp-cont-txt">[시행일] 본 이용약관은 2026년 6월 8일부터 적용됩니다.</p>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script setup lang="ts">
import { ref, onUnmounted, nextTick } from 'vue';

const props = defineProps({
  isTermsPopupOpen: {
    type: Boolean
  }
})

const isSticky = ref(false)
const isExpanded = ref(false)
const stickySentinel = ref<HTMLElement | null>(null)

let observer: IntersectionObserver | null = null

const resetBeforeMove = async () => {
  isExpanded.value = false
  await nextTick()

  const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
  if (listEl) {
    listEl.scrollTo({ top: 0 })
  }
}

const initObserver = () => {
  if (observer) observer.disconnect()

  const scrollEl = document.querySelector('.popup-body') as HTMLElement
  if (!scrollEl || !stickySentinel.value) return

  observer = new IntersectionObserver(
    ([entry]) => {
      isSticky.value = !entry.isIntersecting

      if (entry.isIntersecting) {
        isExpanded.value = false

        const listEl = document.querySelector('.popup-body .terms-privacy-list') as HTMLElement
        if (listEl) {
          listEl.scrollTo({ top: 0 })
        }
      }
    },
    {
      root: scrollEl,
      threshold: 0,
      rootMargin: '10px 0px 0px 0px'
    }
  )

  observer.observe(stickySentinel.value)
}

watch(() => props.isTermsPopupOpen, async (newVal) => {
  if (newVal) {
    await nextTick()
    setTimeout(() => {
      initObserver()
    }, 100)
  } else {
    isSticky.value = false
    isExpanded.value = false
    if (observer) observer.disconnect()
  }
}, {immediate:true})

onUnmounted(() => {
  if (observer) observer.disconnect()
})

</script>
<style lang="scss" scoped>
</style>
